import { render, staticRenderFns } from "./OrderPrint.vue?vue&type=template&id=60164000&scoped=true&"
import script from "./OrderPrint.vue?vue&type=script&lang=js&"
export * from "./OrderPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60164000",
  null
  
)

export default component.exports